import Indexprincipal from './componentes/index.jsx'
import './App.css';

function App() {
  return (
    <div className="App">
       <Indexprincipal/>
     
    </div>
  );
}

export default App;
